export const getAllFromFormData = (
  formData: FormData,
  entityName: string
): Record<string, FormDataEntryValue> => {
  const result: Record<string, FormDataEntryValue> = {};

  formData.forEach((value, formKey) => {
    if (formKey.startsWith(`${entityName}[`)) {
      const nestedKey = formKey.substring(
        entityName.length + 1,
        formKey.length - 1
      );
      result[nestedKey] = value;
    }
  });

  return result;
};
